import { digObject } from '@domain-group/javascript-utils'

import type { FinanceApplicationModel } from '@models/types'

const getApplicationStatus = (financeApplication: FinanceApplicationModel) => {
  const approved = digObject(financeApplication, 'approved')
  const declined = digObject(financeApplication, 'data.declined')

  if (approved) return 'Approved'
  if (declined) return 'Declined'

  return 'Pending'
}

export default getApplicationStatus
